import { render } from "./slideshow.vue?vue&type=template&id=ab374a84&scoped=true"
import script from "./slideshow.vue?vue&type=script&lang=js"
export * from "./slideshow.vue?vue&type=script&lang=js"

import "./slideshow.vue?vue&type=style&index=0&id=ab374a84&scoped=true&lang=css"

import exportComponent from "/Applications/phpstudy/bjhy/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab374a84"]])

export default __exports__